<template>
  <div class="platform-statistics">
    <div class="input-group--horizontal" v-if="statisticsFetched">
      <label
        class="input-horizontal-radio"
        v-for="(timeFrame, index) in timeFrames"
        :key="index"
        >{{ timeFrameLabels[index] }}
        <input
          type="radio"
          name="horizontal-radio-group"
          :checked="index === selectedTimeFrameIndex"
          @change="setSelectedTimeFrame(timeFrame, index)"
        />
        <span class="horizontal-radio-button"></span>
      </label>
    </div>
    <guest-views
      :statistics="statisticsArrayModified"
      v-if="statisticsFetched"
    ></guest-views>
    <div class="double-trouble" v-if="statisticsFetched">
      <guest-interests :statistics="statisticsArrayModified"></guest-interests>
      <guest-information-statistics
        :statistics="statisticsArrayModified"
      ></guest-information-statistics>
    </div>
    <fetching-loader
      displayType="displayBlock"
      v-if="!statisticsFetched"
    ></fetching-loader>
  </div>
</template>

<script>
import GuestViews from "./GuestViews/GuestViews";
import GuestInterests from "./GuestInterests/GuestInterests";
import GuestInformationStatistics from "./GuestInformationStatistics/GuestInformationStatistics";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import { firestore } from "@/firebase";
import { differenceInSeconds, parse } from "date-fns";

export default {
  name: "platform-statistics",
  components: {
    GuestViews,
    GuestInterests,
    GuestInformationStatistics,
    FetchingLoader,
  },
  data() {
    return {
      // timePeriods: null,
      // selectedTimePeriod: 7,
      statisticsArray: null,
      statisticsArrayModified: null,
      statisticsFetched: false,
      selectedTimeFrame: 7,
      selectedTimeFrameIndex: 2 /* Default 7 days */,
      timeFrameLabels: [
        "7 days",
        "2 weeks",
        "1 month",
        "3 months",
        "6 months",
        "1 year",
      ],
      timeFrames: [],
    };
  },
  async created() {
    await this.fetchStatistics();
    await this.updateModifiedArray();
  },
  methods: {
    async fetchStatistics() {
      const querySnapshot = await firestore
        .collection("Statistics")
        .doc(`${this.$hotelId}`)
        .collection("Sorted")
        .get();

      this.statisticsArray = querySnapshot.docs.map((doc) => {
        const extractedDataObject = {
          totalViews: doc.get("totalViews"),
          totalGuests: doc.get("totalGuests"),
          guestsWithoutInfo: doc.get("guestsWithoutInfo"),
          guestsWithPhoneNr: doc.get("guestsWithPhoneNr"),
          guestsWithEmail: doc.get("guestsWithEmail"),
          guestsWithPhoneAndEmail: doc.get("guestsWithPhoneAndEmail"),
          singleDayBoxObject: {},
        };

        // reducing array of objects to an object
        // todo: simply store it as an object in the database?!
        extractedDataObject.singleDayBoxObject = (
          Object.values(doc.get("boxClicked")) || []
        ).reduce(
          (acc, cur) => ({
            ...acc,
            ...Object.entries(cur).reduce(
              (acc, [key, value]) => ({
                ...acc,
                [key]: value,
              }),
              {}
            ),
          }),
          {}
        );

        return [`${doc.id}`, `${doc.data().timestamp}`, extractedDataObject];
      });

      this.amountOfDays();
      this.updateModifiedArray();
    },
    amountOfDays() {
      this.statisticsArray = this.statisticsArray.sort(
        ([firstDate], [secondDate]) => {
          return differenceInSeconds(
            parse(firstDate, "dd-MM-yyyy", new Date()),
            parse(secondDate, "dd-MM-yyyy", new Date())
          );
        }
      );

      if (this.statisticsArray.length <= 7) {
        this.timeFrames = [7];
        this.selectedTimeFrame = 7;
        this.selectedTimeFrameIndex = 0;
      } else if (this.statisticsArray.length <= 28) {
        this.timeFrames = [7, 14];
        this.selectedTimeFrame = 14;
        this.selectedTimeFrameIndex = 1;
      } else if (this.statisticsArray.length <= 91) {
        this.timeFrames = [7, 14, 28];
        this.selectedTimeFrame = 28;
        this.selectedTimeFrameIndex = 2;
      } else {
        this.timeFrames = [7, 14, 28, 91];
        this.selectedTimeFrame = 91;
        this.selectedTimeFrameIndex = 3;
      }

      this.$nextTick(function () {
        this.statisticsFetched = true;
      });
    },
    setSelectedTimeFrame(value, index) {
      this.selectedTimeFrame = value;
      this.selectedTimeFrameIndex = index;
      this.updateModifiedArray();
    },
    updateModifiedArray() {
      switch (this.selectedTimeFrame) {
        case 7:
          if (this.statisticsArray.length < 7) {
            this.statisticsArrayModified = this.statisticsArray;
          } else {
            this.statisticsArrayModified = this.statisticsArray.slice(
              this.statisticsArray.length - 7,
              this.statisticsArray.length
            );
          }
          break;
        case 14:
          if (this.statisticsArray.length < 14) {
            this.statisticsArrayModified = this.statisticsArray;
          } else {
            this.statisticsArrayModified = this.statisticsArray.slice(
              this.statisticsArray.length - 14,
              this.statisticsArray.length
            );
          }
          break;
        case 28:
          if (this.statisticsArray.length < 28) {
            this.statisticsArrayModified = this.statisticsArray;
          } else {
            this.statisticsArrayModified = this.statisticsArray.slice(
              this.statisticsArray.length - 28,
              this.statisticsArray.length
            );
          }
          break;
        case 91:
          if (this.statisticsArray.length < 91) {
            this.statisticsArrayModified = this.statisticsArray;
          } else {
            this.statisticsArrayModified = this.statisticsArray.slice(
              this.statisticsArray.length - 91,
              this.statisticsArray.length
            );
          }
          break;
        default:
          this.statisticsArrayModified = this.statisticsArray;
          break;
      }
    },
  },
};
</script>

<style scoped>
.double-trouble {
  display: flex;
}

.double-trouble > div {
  width: 50%;
}

.double-trouble > div:first-child {
  margin-right: 24px;
}

.double-trouble > div:last-child {
  margin-left: 24px;
}
</style>
